export class IdStatusDto {
    Id: number;
    Status: string;
}


// WEBPACK FOOTER //
// ./src/app/data/framework/IdStatusDto.ts